import { render } from "./BoardHeader.vue?vue&type=template&id=08eb4d8e&scoped=true"
import script from "./BoardHeader.vue?vue&type=script&lang=js"
export * from "./BoardHeader.vue?vue&type=script&lang=js"

import "./BoardHeader.vue?vue&type=style&index=0&id=08eb4d8e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08eb4d8e"]])

export default __exports__